<template>
  <div>
    <ul class="top-10-list">
      <Top10ChartItem v-for="(rankItem, index) in top10Data" :key="index" :index="index" :item="rankItem" />
    </ul>
    <div class="list-gradation" />
  </div>
</template>

<script>
import Top10ChartItem from "./Top10ChartItem";
export default {
  components: {
    Top10ChartItem,
  },
  props: {
    top10Data: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.list-gradation {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8));
}
</style>
